/**
 * Reusable Allen's Bodybuilding wordmark / logo lockup.
 * `size`: 'sm' | 'md' | 'lg' — controls the logo image size.
 * `compact`: if true, shows just the logo image without text (mobile/dashboard nav).
 */
export default function BrandMark({ size = "md", compact = false, className = "" }) {
  const dims = { sm: "w-9 h-9", md: "w-11 h-11", lg: "w-14 h-14" }[size] || "w-11 h-11";
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img src="/logo.jpg" alt="Allen's Bodybuilding" className={`${dims} object-contain`} data-testid="brand-logo" />
      {!compact && (
        <div className="leading-tight">
          <div className="font-display text-base sm:text-lg tracking-[0.18em] uppercase text-white">Allen's</div>
          <div className="font-display text-[10px] sm:text-xs tracking-[0.35em] uppercase text-[#FF3B30]">Bodybuilding</div>
        </div>
      )}
    </div>
  );
}
